(() => {
  const config = JSON.parse(document.getElementById('liora-steam-gifts-config').textContent);
  const root = window.Shopify?.routes?.root || '/';
  const units = item => Number(item.properties?._liora_steam_pack_units) || Number((item.variant_title || config.variants.find(v => Number(v.id) === Number(item.variant_id))?.title || '').match(/(?:מארז|pack)\s*([123])/i)?.[1]) || 1;
  const propertiesFor = type => ({_liora_steam_gift:'true', _liora_steam_gift_type:type, _עבור:'קיטור', _מתנה:'כן'});
  const request = async (path, payload) => {
    const response = await fetch(`${root}cart/${path}.js`, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload)});
    const state = await response.json();
    if (!response.ok || state.errors) throw new Error(state.description || 'Could not synchronize steam gifts');
    return state;
  };
  let queue = Promise.resolve();
  window.LioraSteamGifts = {
    units,
    itemsFor(variantId, quantity, properties = {}) {
      const count = units({variant_id:variantId});
      const mainQuantity = Math.max(1, Number(quantity) || 1);
      return [{id:Number(variantId), quantity:mainQuantity, properties:{...properties, _liora_steam_pack_units:String(count)}},
        ...config.gifts.filter(g => g.id && g.available).map(g => ({id:g.id, quantity:count * mainQuantity, properties:propertiesFor(g.type)}))];
    },
    sync(state, sections) {
      const operation = async () => {
        // Fetch fresh state inside the queue so overlapping cart controls cannot restore stale quantities.
        const latest = await fetch(`${root}cart.js`).then(r => r.json());
        const desired = latest.items.filter(i => i.handle === 'portable-steam-cleaner').reduce((sum,i) => sum + units(i)*i.quantity,0);
        const updates = {}, missing = [];
        for (const gift of config.gifts) {
          const lines = latest.items.filter(i => Number(i.variant_id) === gift.id && (i.properties?._liora_steam_gift === 'true' || gift.type === 'accessory'));
          lines.forEach((item,index) => {const target = index === 0 ? desired : 0; if (item.quantity !== target) updates[item.key] = target;});
          if (desired && !lines.length && gift.available) missing.push({id:gift.id,quantity:desired,properties:propertiesFor(gift.type)});
        }
        if (!Object.keys(updates).length && !missing.length) return state;
        if (missing.length) await request('add',{items:missing});
        return request('update',{updates,sections,sections_url:window.location.pathname});
      };
      const result = queue.then(operation);
      queue = result.catch(() => {});
      return result;
    }
  };
})();
